import { z } from 'zod';
import { BaseEventSchema } from './Base';

export const CartOpenEventSchema = BaseEventSchema.extend({
  access: z.string().optional(),
  products: z.number(),
});

export const CartCloseEventSchema = BaseEventSchema.extend({
  access: z.string().optional(),
  products: z.number(),
});

export enum CartEventTypes {
  CartOpen = 'cart.open',
  CartClose = 'cart.close',
  CartStartPayment = 'cart.start_payment',
}

export const CartEventTrackingSchemas = {
  [CartEventTypes.CartOpen]: CartOpenEventSchema,
  [CartEventTypes.CartClose]: CartCloseEventSchema,
  [CartEventTypes.CartStartPayment]: BaseEventSchema,
} as const;
